import z from 'zod';
export const documentPagesInfoWebhookSchema = z.looseObject({
    type: z.literal('document-pages-info-ready'),
    projectId: z.string(),
    documentId: z.string(),
    correlationId: z.string().optional(),
    uniquePageCount: z.number(),
    pageCount: z.number(),
    pageIds: z.array(z.string()),
    segmentedPages: z
        .array(z.object({
        originalPageId: z.string(),
        pageIndex: z.number().optional(),
        segments: z.array(z.object({
            pageId: z.string(),
            sectionOrder: z.number(),
            heading: z.string().optional(),
        })),
    }))
        .optional(),
});
//# sourceMappingURL=document-pages-info-ready.webhook.js.map